import qs from "qs";

import CountryApi from "../../services/api/Country";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { getPath } from "../../utils";

function handleError(err) {
  console.log("error in country actions:", err);
}

export const setCountryList = (payload) => {
  return {
    type: ActionTypes.SET_COUNTRY_LIST,
    payload,
  };
};

export const setActiveCountry = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_COUNTRY,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_COUNTRY,
    payload,
  };
};

export const setCurrentPageCountry = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_COUNTRY,
    payload,
  };
};

export const getCountryList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let queryParams = {
        ...pageRequest, // no filters ar present for country
      };
      const queryParamsString = qs.stringify(queryParams);
      dispatch(setLoader(true));
      let response = await CountryApi.getCountryList(queryParamsString);
      dispatch(setLoader(false));
      if (response) {
        dispatch(setCountryList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageCountry(getPath(pageRequest, "page", 1)));
        }
        return response;
      }
      return response;
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const getCountry = (id) => async (dispatch) => {
  try {
    const finalPayload = {
      id: id,
    };
    dispatch(setLoader(true));
    const response = await CountryApi.getCountry(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      const countryObj = getPath(response, "country", {});
      dispatch(setActiveCountry(countryObj));
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const createCountry = (data) => async (dispatch) => {
  try {
    const finalPayload = { country: data };
    dispatch(setLoader(true));
    const response = await CountryApi.createCountry(finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(resetState({ state: "activeCountry" }));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.CREATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const updateCountry = (id, data) => async (dispatch) => {
  try {
    const finalPayload = {
      country: data,
    };
    dispatch(setLoader(true));
    const response = await CountryApi.updateCountry(id, finalPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(resetState({ state: "activeCountry" }));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.UPDATION_SUCCESS,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};

export const deleteCountry = (id) => async (dispatch) => {
  try {
    const finalPayload = {
      country_id: String(id),
    };
    dispatch(setLoader(true));
    const response = await CountryApi.deleteCountry(finalPayload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
